import { Component, OnInit, ViewChild } from '@angular/core';
import { MembershipService } from '../../services/membership.service';
import {TranslateService} from '@ngx-translate/core';
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import {
  PaginationArgs,
  MembershipTypeData,
  MembershipData,
  UserProfileData,
  AdministrationResultStatus
} from 'src/app/clients/system-api/SystemApiClient';
import { MatDialog } from "@angular/material/dialog";
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { UserService } from 'src/app/services/user.service';
import {
  WindowDimensions,
  WindowDimensionsService
} from 'src/app/services/window-dimension-service.service';
import { SwipeableModalComponent } from 'src/app/components/modals/generic-modal/swipeable-modal/swipeable-modal.component';
import { DataGridSettingModel, DataGridColumnType, SelectionListModel } from 'src/app/models/data-grid.model';
import { MembershipEnum } from 'src/app/enums/membership';
import * as moment from 'moment';
import { GenericModalComponent } from 'src/app/components/modals/generic-modal/generic-modal.component';

interface MembershipStatus
{
  status: boolean,
  message: string
}

interface MembershipInfo {
  id?: number;
  credits?: number;
  fromDate?: Date;
  toDate?: Date | undefined;
  timeIns?: Date | undefined;
  membershipTypeId?: number;
  profileId?: number;
  membershipTypeName?: string | undefined;
  name?: string | undefined;
  surname?: string | undefined;
  status?: MembershipStatus | undefined;
}

@Component({
  selector: 'app-memberships-page',
  templateUrl: './memberships-page.component.html',
  styleUrls: ['./memberships-page.component.scss']
})
export class MembershipsPageComponent implements OnInit {
  args!: PaginationArgs;
  membershipTypes: MembershipTypeData[] | undefined;
  memberships: MembershipData[] | undefined;
  tempMemberships: MembershipData[] | undefined;
  membershipInfo: MembershipInfo[] | undefined;
  filteredMembershipInfo: MembershipInfo[] | undefined;
  viewMore: boolean[] = [];
  showPopup: boolean = false;
  showNewMembershipPopup: boolean = false;
  selectedType: MembershipTypeData | undefined;
  selectedTypeDelete: MembershipTypeData | undefined;
  isChecked: boolean = false;
  searchMembershipForm!: FormGroup
  todayDate: Date = new Date();
  clients: UserProfileData[] | undefined;
  showActiveOnly: boolean = false;
  windowDimensions: WindowDimensions = {} as WindowDimensions;

  // selectedLanguage: string = 'mk';
  // TransLang: string[] = [];

  //New Membership Popup
  newMembershipForm!: FormGroup;
  addMembershipResult!: AdministrationResultStatus;
  showUserAlreadyExists: boolean = false;
  selectedMembershipType: MembershipTypeData | undefined;
  selectedFromDateNewMembership: Date | undefined;

  //Edit Membership Popup
  editMembershipResult!: AdministrationResultStatus;
  showEditMembershipPopup: boolean = false;
  editMembershipForm!: FormGroup;
  selectedMembership: MembershipInfo | undefined;
  selectedFromDate: Date | undefined;

  //Add Membership Type Popup
  newCategoryForm!: FormGroup
  isActive: boolean = true;
  submitted: boolean = false;

  //Data Grid
  dataGridSettings!: DataGridSettingModel;
  selectionList: SelectionListModel[] = [];

  @ViewChild("newMembershipPopup") NewMembershipPopup!: GenericModalComponent;
  @ViewChild("editMembershipPopup") EditMembershipPopup!: GenericModalComponent;
  @ViewChild("addMembershipTypePopup") AddMembershipTypePopup!: GenericModalComponent;
  @ViewChild("deleteMembershipPopup") DeleteMembershipPopup!: GenericModalComponent;

  //Search
  searchDataActive: boolean = false;

  //Delete Membership Type Popup
  showDeletePopup: boolean = false;

  constructor(private membershipService: MembershipService,
    private userService: UserService,
    private formBuilder: FormBuilder,
    public translateService: TranslateService,
    private _windowDimensionService: WindowDimensionsService) {
 

    this._windowDimensionService
      .getWindowDimensions$()
      .subscribe((dimensions) => {
        this.windowDimensions = dimensions;
      });
    this.isActive = true;
  }

  ngOnInit(): void {
    this.args = new PaginationArgs;
    this.retrieveAllMembershipTypes(this.args);
    this.retrieveAllMemberships(this.args);
    this.retrieveAllClients();
    // this.getTransLanguage();

    this.searchMembershipForm = this.formBuilder.group({
      membershipType: (''),
      client: (''),
      checkbox: [false]
    });


    //New Membership Popup
    this.newMembershipForm = this.formBuilder.group({
      client: new FormControl('', [Validators.required]),
      membership_type: new FormControl('', [Validators.required]),
      valid_from: new FormControl('', [Validators.required]),
      valid_to: new FormControl('')
    });

    //Add Membership Type Popup
    this.newCategoryForm = this.formBuilder.group({
      membership_name: new FormControl('', [Validators.required]),
      session_number: new FormControl('', [Validators.required]),
      service: new FormControl(''),
      price: new FormControl('', [Validators.required]),
      description: new FormControl(''),
    });
    this.newCategoryForm.get('active')?.setValue(true);

    //Edit Membership Popup
    this.editMembershipForm = this.formBuilder.group({
      client: new FormControl('', [Validators.required]),
      membership_type: new FormControl('', [Validators.required]),
      valid_from: new FormControl('', [Validators.required]),
      valid_to: new FormControl(''),
      session_number: new FormControl('', [Validators.required])
    });
  }

  public translate(key: string) {
    return this.translateService.instant(key);
  }

  retrieveAllMembershipTypes(args: PaginationArgs): void {
    this.membershipService.retrieveAllMembershipTypes(args).subscribe(result => {
      this.membershipTypes = result.content?.items;
      for (let i = 0; i < result.content!.items!.length; i++) {
        this.selectionList.push({ "id": result.content!.items![i].id!, "name": result.content!.items![i].name! })
      }
    })
  }

  retrieveAllMemberships(args: PaginationArgs): void {
    this.membershipService.retrieveAllMemberships(args).subscribe(data => {
      this.memberships = data.content?.items;
      if (this.memberships) {
        this.tempMemberships = data.content?.items;
        this.membershipInfo = this.mapToMembershipInfoList(this.memberships!);
        this.filteredMembershipInfo = this.mapToMembershipInfoList(this.memberships!);
      }
    })
  }

  retrieveAllClients() {
    this.userService.retriveAllUsers(2).subscribe(data => {
      this.clients = data.content?.items;
    })
  }

  toggleViewMore(index: number) {
    this.viewMore[index] = !this.viewMore[index];
  }

  preventDefault(event: Event){
    event.preventDefault();
    
  }
//Delete Membership Type

onCloseDeletePopup(){
  if(this.DeleteMembershipPopup){
    this.DeleteMembershipPopup.handleClose();
  }
    this.showDeletePopup = false;
    this.selectedTypeDelete = undefined;
}

onOpenDeletePopup(type: MembershipTypeData){
  this.selectedTypeDelete = type;
  this.showDeletePopup = !this.showDeletePopup;
}

  onDeleteMembershipType(){

    let membershipTypeData = new MembershipTypeData();
    membershipTypeData.active = false;
    membershipTypeData.name = this.selectedTypeDelete?.name;
    membershipTypeData.credits = this.selectedTypeDelete?.credits;
    membershipTypeData.description = this.selectedTypeDelete?.description;
    membershipTypeData.price = this.selectedTypeDelete?.price;
    membershipTypeData.id = this.selectedTypeDelete?.id;
      this.editMembershipType(membershipTypeData)
        .then(() => {

          this.retrieveAllMembershipTypes(this.args);
          this.onCloseDeletePopup();
        });
  }

  openNewCategoryPopup(type?: MembershipTypeData) {
    if (type) {
      this.selectedType = type;
      if (this.selectedType !== undefined) {
        this.newCategoryForm.get('membership_name')?.setValue(this.selectedType.name);
        this.newCategoryForm.get('session_number')?.setValue(this.selectedType.credits);
        this.newCategoryForm.get('price')?.setValue(this.selectedType.price);
        this.newCategoryForm.get('description')?.setValue(this.selectedType.description);
      }
    }
    else {
      this.newCategoryForm.reset();
    }

    this.showPopup = !this.showPopup;
  }

  onCloseAddMembershiptTypePopup() {
    this.selectedType = undefined;
    this.showPopup = false;
    if(this.AddMembershipTypePopup)
    {
    this.AddMembershipTypePopup.handleClose();
    }
  }

  handleCheckboxChange(): void {
    this.isChecked = !this.isChecked;
  }

  public toggleNewMembershipPopup(state?: boolean) {
    this.showNewMembershipPopup = state ?? !this.showNewMembershipPopup;

  }

  searchMembership() {
    this.searchDataActive = true;
    const formValues = this.searchMembershipForm.value;

    if (formValues.membershipType === null || formValues.membershipType === undefined) { formValues.membershipType = ""; }
    if (formValues.client === null || formValues.client === undefined) { formValues.client = ""; }

    if (formValues.membershipType !== "" && formValues.client !== "") {
      let selectedMembershipTypeId = formValues.membershipType;
      let selectedProfileId = formValues.client;
      this.filteredMembershipInfo = this.membershipInfo!.filter(element => element.membershipTypeId == selectedMembershipTypeId && element.profileId == selectedProfileId);
    }
    else if (formValues.membershipType !== "") {
      let selectedMembershipTypeId = formValues.membershipType;
      this.filteredMembershipInfo = this.membershipInfo!.filter(element => element.membershipTypeId == selectedMembershipTypeId);
    }
    else if (formValues.client !== "") {
      let selectedProfileId = formValues.client;
      this.filteredMembershipInfo = this.membershipInfo!.filter(element => element.profileId == selectedProfileId);
    }
    else if ((formValues.membershipType == "") && (formValues.client == "")) {
      this.filteredMembershipInfo = this.membershipInfo;
    }

    if ((formValues.membershipType == "") && (formValues.client !== "")) {
      let selectedProfileId = formValues.client;
      this.filteredMembershipInfo = this.membershipInfo;
      this.filteredMembershipInfo = this.membershipInfo!.filter(element => element.profileId == selectedProfileId);
    }
    else if ((formValues.membershipType !== "") && (formValues.client == "")) {
      let selectedMembershipTypeId = formValues.membershipType;
      this.filteredMembershipInfo = this.membershipInfo;
      this.filteredMembershipInfo = this.membershipInfo!.filter(element => element.membershipTypeId == selectedMembershipTypeId);
    }
  }

  cancelSearchData() {
    this.searchDataActive = false;
    this.filteredMembershipInfo = this.membershipInfo;
    this.searchMembershipForm.reset();
  }

  mapToMembershipInfoList(membershipDataList: MembershipData[]): MembershipInfo[] {
    const todayDate = new Date();
    return membershipDataList.map(item => {
      const status =
        (todayDate && item.fromDate && item.toDate && todayDate <= item.toDate) || item.toDate == undefined
          ? {status: true, message: this.translate('active')} as MembershipStatus
          : {status: false, message: this.translate('used')} as MembershipStatus;

      return {
        ...item,
        status: status,
      } as MembershipInfo;
    });
  }

  //Edit Membership
  openEditMembershipPopup(membershipInfo: MembershipInfo | undefined) {
    this.showEditMembershipPopup = true;
    this.selectedMembership = membershipInfo;
    const fromDate = membershipInfo?.fromDate ? new Date(membershipInfo.fromDate) : new Date();
    const formattedFromDate = fromDate.toLocaleDateString('en-CA');
    const toDate = membershipInfo?.toDate ? new Date(membershipInfo.toDate) : undefined;
    const formattedToDate = toDate?.toLocaleDateString('en-CA');
    this.editMembershipForm.get('client')?.setValue(membershipInfo?.profileId);
    this.editMembershipForm.get('membership_type')?.setValue(membershipInfo?.membershipTypeId);
    this.editMembershipForm.get('valid_from')?.setValue(formattedFromDate);
    this.editMembershipForm.get('valid_to')?.setValue(formattedToDate);
    this.editMembershipForm.get('session_number')?.setValue(membershipInfo?.credits);

    this.selectedFromDate = membershipInfo?.fromDate;
    if(this.selectedFromDate){
      const nextDay = new Date(this.selectedFromDate);
      nextDay.setDate(nextDay.getDate() + 1);
      this.selectedFromDate = nextDay;
    }
  }

  onCloseEditMembershipPopup() {
    this.showEditMembershipPopup = false;
    if(this.EditMembershipPopup)
    {
      this.EditMembershipPopup.handleClose();
    }
  }

  onEditMembership() {
    const formValues = this.editMembershipForm.value;
    let membershipData = new MembershipData();

    let profileId = formValues.client;
    let fromDate = new Date(formValues.valid_from);
    let toDate = undefined;
    if (formValues.valid_to !== '') {
      toDate = new Date(formValues.valid_to);
      membershipData.toDate = moment(toDate).utc(true).toDate();
    }


    membershipData.id = this.selectedMembership?.id;
    membershipData.fromDate = moment(fromDate).utc(true).toDate();
    membershipData.profileId = profileId;
    let selectedMembershipTypeId = formValues.membership_type;

    this.selectedMembershipType = this.membershipTypes!.find(element => element.id == selectedMembershipTypeId);
    membershipData.membershipTypeId = this.selectedMembershipType?.id;
    membershipData.membershipTypeName = this.selectedMembershipType?.name;
    membershipData.credits = formValues.session_number;
    this.editMembership(membershipData)
      .then(() => {
        if (this.addMembershipResult == AdministrationResultStatus.RecordAlreadyExists) {
          this.showUserAlreadyExists = true;
          return;
        }
        this.retrieveAllMemberships(this.args);
        this.onCloseEditMembershipPopup();
      });
  }

  onDateChange(event: any): void {
    const date = event.value;
    if(date){
      const nextDay = new Date(date);
      nextDay.setDate(nextDay.getDate() + 1);
      this.selectedFromDate = nextDay;
    }
  }


  //New Membeship Popup Functions
  newMembershipPopup() {
    this.showNewMembershipPopup = !this.showNewMembershipPopup;
  }

  onAddNewMembership() {
    this.showUserAlreadyExists = false;
    if (this.newMembershipForm.invalid) { return; }

    const formValues = this.newMembershipForm.value;
    let membershipData = new MembershipData();
    let profileId = formValues.client;
    let fromDate = new Date(formValues.valid_from);
    let toDate = undefined;
    if (formValues.valid_to !== '') {
      toDate = new Date(formValues.valid_to);
      membershipData.toDate = moment(toDate).utc(true).toDate();
    }

    membershipData.fromDate = moment(fromDate).utc(true).toDate();
    membershipData.profileId = profileId;
    let selectedMembershipTypeId = formValues.membership_type;

    this.selectedMembershipType = this.membershipTypes!.find(element => element.id == selectedMembershipTypeId);
    membershipData.membershipTypeId = this.selectedMembershipType?.id;
    membershipData.membershipTypeName = this.selectedMembershipType?.name;
    membershipData.credits = this.selectedMembershipType?.credits;
    this.addMembership(membershipData)
      .then(() => {
        if (this.addMembershipResult == AdministrationResultStatus.RecordAlreadyExists) {
          this.showUserAlreadyExists = true;
          return;
        }
        this.retrieveAllMemberships(this.args);
        this.onCloseMembershipPopup();
      });
  }

  onCloseMembershipPopup() {
    if(this.NewMembershipPopup){
      this.NewMembershipPopup.handleClose();
      this.newMembershipForm.reset();
      this.newMembershipForm.get('client')?.setValue('');
      this.newMembershipForm.get('membership_type')?.setValue('');
    }

    this.showNewMembershipPopup = false;
  }

  onDateChangeNewMembership(event: any): void {
    const date = event.value;
    if(date){
      const nextDay = new Date(date);
      nextDay.setDate(nextDay.getDate() + 1);
      this.selectedFromDateNewMembership = nextDay;
    }
  }

  getTodayDate(): string {
    const today = new Date();
    const month = (today.getMonth() + 1).toString().padStart(2, '0');
    const day = today.getDate().toString().padStart(2, '0');
    return `${today.getFullYear()}-${month}-${day}`;
  }

  addMembership(membershipData: MembershipData | undefined): Promise<void> {
    return new Promise<void>((resolve) => {
      this.membershipService.addMembership(membershipData).subscribe((data) => {
        this.addMembershipResult = data;
        resolve();
      });
    });
  }

  editMembership(membershipData: MembershipData | undefined): Promise<void> {
    return new Promise<void>((resolve) => {
      this.membershipService.editMembership(membershipData).subscribe((data) => {
        this.editMembershipResult = data;
        resolve();
      })
    });
  }
  //Add Membership Type Popup functions
  addNewMembershipType() {
    if (this.newCategoryForm.invalid) {
      return;
    }

    const formValues = this.newCategoryForm.value;
    let membershipTypeData = new MembershipTypeData();
    membershipTypeData.active = true;
    membershipTypeData.name = formValues.membership_name;
    membershipTypeData.credits = formValues.session_number;
    membershipTypeData.description = formValues.description;
    membershipTypeData.price = formValues.price;

    if (this.selectedType == undefined) {
      this.addMembershipTypes(membershipTypeData)
        .then(() => {
          this.retrieveAllMembershipTypes(this.args);
          this.onCloseAddMembershiptTypePopup();

        });
    }
    else {
      membershipTypeData.id = this.selectedType.id;
      this.editMembershipType(membershipTypeData)
        .then(() => {
          this.retrieveAllMembershipTypes(this.args);
          this.onCloseAddMembershiptTypePopup();
        });
    }
  }

  addMembershipTypes(body: MembershipTypeData | undefined): Promise<void> {
    return new Promise<void>((resolve) => {
      this.membershipService.addMembershipType(body).subscribe((_data) => {
        resolve();
      });
    });
  }

  editMembershipType(body: MembershipTypeData | undefined): Promise<void> {
    return new Promise<void>((resolve) => {
      this.membershipService.editMembershipType(body).subscribe((_data) => {
        resolve();
      });
    });
  }

}
